import { useEffect, useRef } from 'react';
import type { CaptureWorkState } from './useCostCapture';
export type JourneyWorkCallback = (state: CaptureWorkState) => void;
/** Forms report state; their containing review owns one navigation/close prompt. */
export function useJourneyReviewWork(state: CaptureWorkState, onWorkStateChange?: JourneyWorkCallback) {
  const callback = useRef(onWorkStateChange); callback.current = onWorkStateChange;
  useEffect(() => { callback.current?.(state); }, [state.busy, state.dirty]);
  useEffect(() => () => callback.current?.({ busy: false, dirty: false }), []);
}
